import { render, staticRenderFns } from "./DescriptionZones.vue?vue&type=template&id=0e7ef778&scoped=true&"
import script from "./DescriptionZones.vue?vue&type=script&lang=js&"
export * from "./DescriptionZones.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionZones.vue?vue&type=style&index=0&id=0e7ef778&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7ef778",
  null
  
)

export default component.exports